//
/* global window */

import loadJavascript from '../loadJavascript';

const noop = () => {};

// aftId will be in the format of "[conversion_id]/[conversion_label]", i.e.
// "AW-847031165/mwM3CNOI0oIBEP3W8pMD". For the initial page load, we only want the conversion id
// portion. For event tracking we want the full aftId.
function getConversionId(aftId) {
  return decodeURIComponent(aftId).split('/')[0];
}

function loadAdwords(aftId, layer = 'affiliateDataLayer') {
  if (typeof window === 'undefined') {
    return noop;
  }
  window[layer] = window[layer] || [];
  function gtag() {
    // DO NOT CHANGE
    // For whatever reason, this does not trigger the event logging if you use `...args`.
    window[layer].push(arguments); // eslint-disable-line prefer-rest-params
  }
  const conversionId = getConversionId(aftId);
  loadJavascript(`https://www.googletagmanager.com/gtag/js?id=${conversionId}&l=${layer}`);
  return gtag;
}

export async function trackPage(aftId) {
  const gtag = loadAdwords(aftId);
  gtag('js', new Date());
  gtag('config', getConversionId(aftId));
}

export async function trackEvent(aftId, event) {
  if (event !== 'Scheduled Appointment') {
    return;
  }
  const gtag = loadAdwords(aftId);
  gtag('event', 'conversion', {
    send_to: decodeURIComponent(aftId),
  });
}
